import {theme as base} from '@chakra-ui/react'
import {FontTheme} from '../types/typography.types'

const fonts: FontTheme = {
    fonts: {
        heading: `'SofiaPro', 'Noto Sans', ${base.fonts?.heading}`,
        body: `'SofiaPro', 'Noto Sans', ${base.fonts?.body}`,
        primary: `'SofiaPro', 'Noto Sans', ${base.fonts?.heading}`,
        secondary: `'SofiaPro', 'Noto Sans', ${base.fonts?.body}`,
    },
}

export default fonts
